import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PreferredPartnerT, RecommendedPartnerT, PreferredPartnerDrawerDataT, AutocompletePartnerT } from "./types";
import { LaborPartnerKindEnum } from "./enums";

export type LaborPartnersReduxStateT = {
  laborPartners: {
    paging: {
      itemCount: number;
      pageNumber: number;
      pageSize: number;
      hasMore: boolean;
    };
    preferredPartners: PreferredPartnerT[];
    recommendedLaborPartners: RecommendedPartnerT[];
    partnerAutocomplete: AutocompletePartnerT[];
    preferredPartnerDrawer: {
      isVisible: boolean;
      partnerKind: LaborPartnerKindEnum;
    };
  };
};

const preferredPartnerDrawerClosedState = {
  isVisible: false,
  partnerKind: LaborPartnerKindEnum.SOLAR,
};

const initialState: LaborPartnersReduxStateT = {
  laborPartners: {
    paging: {
      itemCount: 0,
      pageNumber: 0,
      pageSize: 0,
      hasMore: false,
    },
    preferredPartners: [],
    recommendedLaborPartners: [],
    partnerAutocomplete: [],
    preferredPartnerDrawer: preferredPartnerDrawerClosedState,
  },
};

export const laborPartnersSlice = createSlice({
  name: "laborPartners",
  initialState,
  reducers: {
    setPreferredPartnerDrawerVisible(state, action: PayloadAction<PreferredPartnerDrawerDataT>) {
      state.laborPartners.preferredPartnerDrawer = action.payload;
    },
    setPreferredPartnerDrawerClosed(state) {
      state.laborPartners.preferredPartnerDrawer = preferredPartnerDrawerClosedState;
    },
  },
  selectors: {
    selectPreferredPartnerDrawerData: (state) => state.laborPartners.preferredPartnerDrawer,
  },
});
export const { laborPartners: preferredPartnersInitialState } = initialState;
export const { setPreferredPartnerDrawerVisible, setPreferredPartnerDrawerClosed } = laborPartnersSlice.actions;
export const { selectPreferredPartnerDrawerData } = laborPartnersSlice.selectors;
